import axiosInstance, { CustomAxiosRequestConfig } from "../services/axios";
import { IProperties } from "../types";
import { Endpoints } from "./endpoint";
import { QueryObject } from "./global";


export const createPropertyApi=async(payload:Partial<IProperties>)=>{
    const res = await axiosInstance.post(
        `${process.env.NEXT_PUBLIC_API}${Endpoints.PROPERTIES.CREATE}`,
        payload,
        {
            requiresAuth: true // Custom property to skip auth
        } as CustomAxiosRequestConfig
    );
    return res.data;
}

export const updatePropertyApi=async(payload:Partial<IProperties>)=>{
    const {_id,...data}=payload;
    console.log(payload);
    
    const res = await axiosInstance.put(
        `${process.env.NEXT_PUBLIC_API}${Endpoints.PROPERTIES.CREATE}/${_id}`,
        data,
        {
            requiresAuth: true // Custom property to skip auth
        } as CustomAxiosRequestConfig
    );
    return res.data;
}

export const RemovePropertyApi=async(id:string)=>{
   
    const res = await axiosInstance.delete(
        `${process.env.NEXT_PUBLIC_API}${Endpoints.PROPERTIES.CREATE}/${id}`,
       
        {
            requiresAuth: true // Custom property to skip auth
        } as CustomAxiosRequestConfig
    );
    return res.data;
}

export const getPropertyApi=async(id:string)=>{
    if (!id) return
    const res = await axiosInstance.get(
        `${process.env.NEXT_PUBLIC_API}${Endpoints.PROPERTIES.CREATE}/${id}`,
        {
            requiresAuth: true // Custom property to skip auth
        } as CustomAxiosRequestConfig
    );
    return res.data;
}


export const getPropertiesApi=async(payload:Partial<QueryObject<{name:string,location:string,propertyType:string,status:string}>>)=>{
    

	let url = `${process.env.NEXT_PUBLIC_API}${Endpoints.PROPERTIES.CREATE}`;
	const queryParams = [];
  
	if (payload.page !== undefined) {
	  queryParams.push(`page=${payload.page}`);
	}
    if(payload.name!==undefined){
        queryParams.push(`name=${payload.name}`);
    }
      if(payload.location!==undefined){
        queryParams.push(`location=${payload.location}`);
    }

    if(payload.status!==undefined){
        queryParams.push(`status=${payload.status}`);
    }


     if(payload.propertyType!==undefined){
        queryParams.push(`propertyType=${payload.propertyType}`);
    }
	
	if (payload.limit !== undefined) {
	  queryParams.push(`limit=${payload.limit}`);
	}
	queryParams.push(`populate=media,documents`);
	if (queryParams.length > 0) {
	  url += `?${queryParams.join('&')}`;
	}
  
	const res = await axiosInstance.get(url);
	return res.data;
}